import React, { useEffect, useRef } from "react";
import css from "../../style/visionStyle.module.css";

const BottomSheet = ({ isOpen, onClose, children }) => {
  const bottomSheetRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        bottomSheetRef.current &&
        !bottomSheetRef.current.contains(event.target)
      ) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className={css.bottomSheetOverlay}>
      <div ref={bottomSheetRef} className={css.bottomSheet}>
        <div className={css.bottomSheetHandle} />
        {children}
      </div>
    </div>
  );
};

export default BottomSheet;
